import {
  ballArr,
  count,
  singleDouble,
  smallBig
} from "../../../../helpers/resPatterns";

const PL5 = () => {
  const list = Vue => {
    return [
      {
        title: "时间",
        align: "center",
        render: (h, { row }) => {
          return <span>{row.result_time}</span>;
        }
      },
      {
        title: "期数",
        align: "center",
        key: "issue_id"
      },
      {
        title: "开奖号码",
        align: "center",
        render: (h, { row }) => {
          return (
            <div class="ball num">
              {ballArr(row.balls).map((x, i) => {
                return (
                  <span style={{ border: `1px solid  #1299df` }}>{x}</span>
                );
              })}
            </div>
          );
        }
      },
      {
        title: "总和",
        align: "center",
        render: (h, { row }) => {
          let arr = ballArr(row.balls);
          return (
            <div class="insideTableTd">
              <p class="count brr">{count(arr)}</p>
              <p class="singleDouble brr">
                {singleDouble(count(arr)) == 0 ? (
                  <span class="blue">单</span>
                ) : (
                  <span class="red">双</span>
                )}
              </p>
            </div>
          );
        }
      }
    ];
  };
  return { list };
};
const PL3 = () => {
  const list = Vue => {
    return [
      {
        title: "时间",
        align: "center",
        width: "180",
        render: (h, { row }) => {
          return <span>{row.result_time}</span>;
        }
      },
      {
        title: "期数",
        align: "center",
        key: "issue_id"
      },
      {
        title: "开奖号码",
        align: "center",
        render: (h, { row }) => {
          return (
            <div class="ball num">
              {ballArr(row.balls).map((x, i) => {
                return (
                  <span style={{ border: `1px solid  #1299df` }}>{x}</span>
                );
              })}
            </div>
          );
        }
      },
      {
        title: "佰拾和",
        align: "center",
        width: 160,
        render: (h, { row }) => {
          let arr = ballArr(row.balls);
          let n = arr[0] + arr[1];
          let s = n.toString().slice(-1);
          return (
            <div class="insideTableTd">
              <p class="count brr">{n}</p>
              <p class="singleDouble brr">
                {singleDouble(n) == 0 ? (
                  <span class="blue">单</span>
                ) : (
                  <span class="red">双</span>
                )}
              </p>
              <p class="smallBig">
                {s < 5 ? (
                  <span class="blue">尾小</span>
                ) : (
                  <span class="red">尾大</span>
                )}
              </p>
            </div>
          );
        }
      },
      {
        title: "佰个和",
        align: "center",
        width: 160,
        render: (h, { row }) => {
          let arr = ballArr(row.balls);
          // let n = count(arr.slice(1, 3));
          let n = arr[0] + arr[2];
          let s = n.toString().slice(-1);
          return (
            <div class="insideTableTd">
              <p class="count brr">{n}</p>
              <p class="singleDouble brr">
                {singleDouble(n) == 0 ? (
                  <span class="blue">单</span>
                ) : (
                  <span class="red">双</span>
                )}
              </p>
              <p class="smallBig">
                {s < 5 ? (
                  <span class="blue">尾小</span>
                ) : (
                  <span class="red">尾大</span>
                )}
              </p>
            </div>
          );
        }
      },
      {
        title: "拾个和",
        align: "center",
        width: 160,
        render: (h, { row }) => {
          let arr = ballArr(row.balls);
          let n = arr[1] + arr[2];
          let s = n.toString().slice(-1);
          return (
            <div class="insideTableTd">
              <p class="count brr">{n}</p>
              <p class="singleDouble brr">
                {singleDouble(n) == 0 ? (
                  <span class="blue">单</span>
                ) : (
                  <span class="red">双</span>
                )}
              </p>
              <p class="smallBig">
                {s < 5 ? (
                  <span class="blue">尾小</span>
                ) : (
                  <span class="red">尾大</span>
                )}
              </p>
            </div>
          );
        }
      },
      {
        title: "总和",
        align: "center",
        render: (h, { row }) => {
          let arr = ballArr(row.balls);
          return (
            <div class="insideTableTd">
              <p class="count brr">{count(arr)}</p>
              <p class="singleDouble brr">
                {singleDouble(count(arr)) == 0 ? (
                  <span class="blue">单</span>
                ) : (
                  <span class="red">双</span>
                )}
              </p>
              <p class="smallBig">
                {smallBig(count(arr), 27) == 0 ? (
                  <span class="blue">小</span>
                ) : (
                  <span class="red">大</span>
                )}
              </p>
            </div>
          );
        }
      }
    ];
  };
  return { list };
};
export default type => {
  if (type == "PL3" || type == "FC3D") {
    return PL3();
  }
  if (type == "PL5" || type == "SSQ") {
    return PL5();
  }

  // if (type == 'choose5') {
  //   return getchoose5(list);
  // }
};
// export default xyrb;



// WEBPACK FOOTER //
// ./src/pages/Trend/Jishikaijiang/columns/three.js